(() => {
  const records = new WeakMap();
  const state = (plate, value) => {
    if (plate.dataset.cardMedia !== value) plate.dataset.cardMedia = value;
    plate.setAttribute('aria-busy', value === 'loading' ? 'true' : 'false');
  };
  const decode = async image => {
    if (image.decode) await image.decode();
    if (!image.complete || !image.naturalWidth) throw Error('Image unavailable');
  };
  function imageReady(plate, record, image, value) {
    const source = image.currentSrc || image.src;
    if (record.image === image && record.source === source && record.value === value) return;
    record.image = image; record.source = source; record.value = value;
    const token = ++record.token;
    state(plate, 'loading');
    decode(image).then(() => {
      if (record.token === token && plate.isConnected && (image.currentSrc || image.src) === source) state(plate, value);
    }).catch(() => {
      if (record.token === token && image.complete && !image.naturalWidth) state(plate, 'error');
    });
  }
  function update(plate) {
    let record = records.get(plate);
    if (!record) {
      record = { token: 0, visible: false };
      records.set(plate, record);
      visibility.observe(plate);
    }
    const viewer = plate.querySelector('.gg-card__model > gg-model-viewer');
    if (!viewer) {
      clearTimeout(record.timer); record.timer = null;
      const image = plate.querySelector(':scope > img.gg-card__img');
      if (image) imageReady(plate, record, image, 'image');
      return;
    }
    if (!viewer.hasAttribute('data-model-loaded') && viewer.hasAttribute('data-card-rendered')) delete viewer.dataset.cardRendered;
    if (viewer.hasAttribute('data-model-loaded') && viewer.hasAttribute('data-card-rendered') && !viewer.hasAttribute('data-model-error')) {
      ++record.token; record.image = null; record.timedOut = false;
      clearTimeout(record.timer); record.timer = null;
      state(plate, 'model');
      return;
    }
    if (viewer.hasAttribute('data-model-error') || record.timedOut) {
      const fallback = plate.querySelector('.gg-card__model-still');
      if (fallback) imageReady(plate, record, fallback, 'fallback');
      else state(plate, 'error');
      return;
    }
    if (record.image) { ++record.token; record.image = null; }
    state(plate, 'loading');
    if (record.visible && !record.timer) record.timer = setTimeout(() => {
      record.timer = null; record.timedOut = true; update(plate);
    }, 15000);
  }
  const visibility = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
    const record = records.get(target);
    if (!record) return;
    record.visible = isIntersecting;
    if (!isIntersecting) { clearTimeout(record.timer); record.timer = null; }
    else update(target);
  }));
  const scan = () => document.querySelectorAll('.gg-card__media').forEach(update);
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  };
  new MutationObserver(schedule).observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['src', 'srcset', 'data-model-loaded', 'data-model-error', 'data-card-rendered']
  });
  document.addEventListener('load', event => {
    if (event.target.matches?.('.gg-card__img, .gg-card__model-still')) {
      const plate = event.target.closest('.gg-card__media');
      const record = plate && records.get(plate);
      if (record && plate.dataset.cardMedia !== 'model') { record.image = null; update(plate); }
    }
  }, true);
  document.addEventListener('error', event => {
    if (event.target.matches?.('.gg-card__img, .gg-card__model-still')) {
      const plate = event.target.closest('.gg-card__media');
      if (plate && plate.dataset.cardMedia !== 'model') state(plate, 'error');
    }
  }, true);
  customElements.whenDefined('gg-model-viewer').then(() => {
    const proto = customElements.get('gg-model-viewer').prototype;
    const render = proto.render;
    proto.render = function (time) {
      render.call(this, time);
      if (this.dataset.modelLoaded && !this.dataset.modelError && this.renderer && this.drawnAt && !this.dataset.cardRendered) this.dataset.cardRendered = 'true';
    };
    document.querySelectorAll('.gg-card gg-model-viewer').forEach(viewer => {
      if (viewer.dataset.modelLoaded && viewer.drawnAt) viewer.dataset.cardRendered = 'true';
    });
    schedule();
  });
  scan();
})();
